$(document).ready(function() {
    lightbox.option({
        'maxWidth': 900,
        'resizeDuration': 200,
        'wrapAround': true,
        'fadeDuration': 200
    })

    var slider = $('.intro-slider').unslider({
        autoplay: true,
        nav: false,
        speed: 750,
        delay: 6000
    });

    $('.intro-slider').mouseover(function() {
        slider.unslider('stop');
    })
    .mouseout(function(){
        slider.unslider('start');
    });

    $('#portfolio').mixItUp();
});
